/**
 * Notice + Notices: aviso individual + contenedor (sección "Avisos"
 * del Dashboard del vecino).
 *
 * Sprint 11 v2 S11-V2-06. Replica `.cb-notice` + `.cb-notices` del
 * handoff (`docs/COMPONENTES.md § Notices y notice`).
 *
 * Estos avisos son comunicados de la Comisión (cambios de horario,
 * asambleas, mantenimientos). NO son alertas operativas del vecino
 * (esas van en el Greeting split + Bell del Header).
 */
import type { ReactNode } from 'react';

interface NoticesProps {
  children: ReactNode;
}

interface NoticeProps {
  title: ReactNode;
  text?: ReactNode;
  time?: ReactNode;
  unread?: boolean;
  onClick?: () => void;
}

export function Notices({ children }: NoticesProps) {
  return (
    <div className="border-[0.5px] border-white/[0.08] rounded-md overflow-hidden">
      {children}
    </div>
  );
}

export function Notice({
  title,
  text,
  time,
  unread = false,
  onClick,
}: NoticeProps) {
  const bgClass = unread ? 'bg-bg-sunken' : 'bg-bg-card hover:bg-bg-sunken';
  const dotClass = unread ? 'bg-orange' : 'bg-transparent';
  const titleClass = unread
    ? 'text-text-primary font-medium'
    : 'text-text-secondary';
  const textClass = unread ? 'text-text-secondary' : 'text-text-muted';

  return (
    <div
      className={`px-4 py-3 flex items-start gap-3 border-b-[0.5px] border-white/[0.08] last:border-b-0 cursor-pointer transition-colors duration-base ${bgClass}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div
        className={`w-[6px] h-[6px] rounded-full mt-[6px] flex-shrink-0 ${dotClass}`}
        aria-hidden="true"
      />
      <div className="flex-1">
        <div className={`text-base ${titleClass}`}>{title}</div>
        {text && <div className={`text-sm mt-[2px] ${textClass}`}>{text}</div>}
      </div>
      {time && <div className="text-xs text-text-muted whitespace-nowrap">{time}</div>}
    </div>
  );
}
